import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_KEY;
const aesKey    = process.env.REACT_APP_AESKEY;
const aesIVKey  = process.env.REACT_APP_AESIVKEY;

const Key = CryptoJS.enc.Base64.parse(aesKey);
const IV  = CryptoJS.enc.Base64.parse(aesIVKey);

function encryptStorageData(data) {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey);
    return encryptedData.toString();
}

function decryptStorageData(encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

const encryptAES = (data) => {
    const input = typeof data === 'object' ? JSON.stringify(data) : data?.toString();
    const encrypted = CryptoJS.AES.encrypt(input, Key, {
        iv:      IV,
        mode:    CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

const decryptAES = (encryptedData) => {
    const cipherText =
        typeof encryptedData === 'object'
            ? encryptedData?.responseData
            : encryptedData;

    if (!cipherText || typeof cipherText !== 'string') {
        throw new Error('decryptAES: no cipherText to decrypt');
    }

    try {
        const decrypted = CryptoJS.AES.decrypt(cipherText, Key, {
            iv:      IV,
            mode:    CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
        throw new Error('decryptAES: decryption returned empty string — check Key/IV');
    }

        return decryptedText;
    } catch {
        return null;
    }
};


const encryptUrlData = (data) =>
    encryptAES(data).replaceAll('/', 's2e0s21').replaceAll('+', 's2e0s22');

const decryptUrlData = (data) => {
    const normalised = data.replaceAll('s2e0s21', '/').replaceAll('s2e0s22', '+');
    return decryptAES(normalised);
};

export {
    encryptStorageData,
    decryptStorageData,
    encryptAES,
    decryptAES,
    encryptUrlData,
    decryptUrlData
};